import { isNotEmptyArray } from '@vy/utils';
import { useEffect, useRef } from 'react';
import { useQueryClient } from 'react-query';
import { queryKeys } from '../../../../services/query-key/query-keys';

type Task = { id: string };

export function useInvalidateOnTaskCompletion(activeTasks: Task[]) {
  const queryClient = useQueryClient();
  const prevTaskIdsRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    const currentTaskIds = new Set(activeTasks.map((task) => task.id));
    const disappearedTaskIds = [...prevTaskIdsRef.current].filter((taskId) => !currentTaskIds.has(taskId));

    if (isNotEmptyArray(disappearedTaskIds)) {
      void queryClient.invalidateQueries(queryKeys.contracts());
    }

    prevTaskIdsRef.current = currentTaskIds;
  }, [activeTasks, queryClient]);
}
